export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: ['yes', 'no'],
    OFFLINE_MESSAGE:
      'Sorry, I don\'t have an internet connection at the moment. Therefore I can\'t process your answer.'
  }
}
